export default "__VITE_PUBLIC_ASSET__cfb7b12f__"